
import { GeneticsMap } from '@/services/crossbreeding-service/models';
import { Component, Vue, Prop } from 'vue-property-decorator';
import SaplingGeneRepresentation from './SaplingGeneRepresentation.vue';
import SimulationMapGroup from './SimulationMapGroup.vue';
import SaplingDetailed from './SaplingDetailed.vue';

@Component({
  components: { SaplingGeneRepresentation, SimulationMapGroup, SaplingDetailed }
})
export default class SimulationMap extends Vue {
  @Prop({ type: Object, required: true }) readonly map!: GeneticsMap;
  @Prop({ type: Boolean }) readonly enableComposingSaplingsSelection: boolean;
  @Prop({ type: Boolean }) readonly enableMapSelection: boolean;
  @Prop({ type: Boolean }) readonly enableGeographicalDirectionTips: boolean;
  @Prop({ type: Boolean }) readonly enableTooltip: boolean;
  @Prop({ type: Boolean }) readonly enableRipple: boolean;
  @Prop({ type: Number }) readonly forcedHeight: number;

  get chanceClass() {
    let chanceClass = 'map_chance--';
    if (this.map.chance > 0.5) {
      chanceClass += 'high';
    } else {
      chanceClass += 'moderate';
    }
    return chanceClass;
  }

  get genClass() {
    return `map_gen--${this.map.resultSapling.generationIndex}`;
  }

  get showGeographicalDirectionTips() {
    return this.enableGeographicalDirectionTips && this.map.chance < 1;
  }

  handleCrossbreedingSaplingSelection(crossbreedingSaplingIndex: number) {
    if (this.map.crossbreedingSaplingsVariants) {
      this.$emit('composing-sapling-selected', this.map.crossbreedingSaplingsVariants[crossbreedingSaplingIndex]);
    }
  }

  handleBaseSaplingSelection() {
    if (this.map.baseSaplingVariants) {
      this.$emit('composing-sapling-selected', this.map.baseSaplingVariants);
    }
  }
}
